import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { useAppSelector } from './use-app-selector';

const useSetSentryUser = () => {
  const user = useAppSelector((state) => state.auth.user);
  const cookiesAccepted = useAppSelector((state) => state.layout.cookiesAccepted);

  useEffect(() => {
    if (user && cookiesAccepted) {
      Sentry.setUser({
        id: user.id,
      });
    } else {
      Sentry.setUser(null);
    }
  }, [user, cookiesAccepted]);
};

export { useSetSentryUser };
